export default {
  // Campos específicos
  certification: 'Certificación',
  institutional: 'Institucional',
  profiles: 'Perfiles',
  startLevel: 'Nivel de Inicio',
  endLevel: 'Nivel de Término',

  // Acciones específicas
  goToProfile: 'Ir al perfil',
  fieldNMustNotExceed: 'Este campo no debe superar el 100',

  // Títulos de tabs
  entityData: 'Datos del {entity}',
  assignEntity: 'Asignar {entity}',

  // Mensajes masculinos (para Ciclo)
  createdMale: 'creado.',
  updatedMale: 'actualizado.',
  deletedMale: 'eliminado.',

  // Mensajes de relación
  relationshipCreated: 'Relación entre {entity1} y {entity2} creada.',
  relationshipUpdated: 'Relación entre {entity1} y {entity2} actualizada.',
  entityDeletedFromEntity: '{entity1} eliminado del {entity2}.',
}
